import { render, staticRenderFns } from "./HuntingWordsForm.vue?vue&type=template&id=13c15f62&scoped=true"
import script from "./HuntingWordsForm.vue?vue&type=script&lang=js"
export * from "./HuntingWordsForm.vue?vue&type=script&lang=js"
import style0 from "./HuntingWordsForm.vue?vue&type=style&index=0&id=13c15f62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c15f62",
  null
  
)

export default component.exports